import { FinecoDownloadIcon } from "shared/assets/svg/FinecoDownloadIcon";
import styles from "./finecoDownloadButton.module.scss";

type FinecoDownloadButtonProps = {
  click: () => void;
  copy: string;
  disabled?: boolean;
  white?: boolean;
};
export const FinecoDownloadButton: React.FC<FinecoDownloadButtonProps> = ({
  click,
  copy,
  disabled = false,
  white = false,
}) => {
  return (
    <button
      type="button"
      className={styles.buttonContainer}
      onClick={click}
      disabled={disabled}
      aria-label={copy}
      style={disabled ? { opacity: 0.5 } : undefined}
    >
      <div className={styles.icon}>
        <FinecoDownloadIcon />
      </div>
      <span className={styles.buttonCopy}>
        {copy}
      </span>
    </button>
  );
};
